import { render, staticRenderFns } from "./uploadFileManager.vue?vue&type=template&id=3bc34164"
import script from "./uploadFileManager.vue?vue&type=script&lang=js"
export * from "./uploadFileManager.vue?vue&type=script&lang=js"
import style0 from "./uploadFileManager.vue?vue&type=style&index=0&id=3bc34164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports